import * as MuiStepLabel from '@mui/material/StepLabel'
import React from 'react'

export type StepLabelProps = MuiStepLabel.StepLabelProps

export function StepLabel({ children, ...props }: StepLabelProps) {
  return <MuiStepLabel.default {...props}>{children}</MuiStepLabel.default>
}
